import Router from "./components/Router"
import { useClearTestTenantOnAuthChange } from "./hooks/use-clear-test-tenant-on-auth-change"

export default () => {
    useClearTestTenantOnAuthChange()
    return <Router />
}
